import {
  FETCH_ACUMATICA_FAILURE_LOGS_REQUEST,
  FETCH_ACUMATICA_FAILURE_LOGS_SUCCESS,
  FETCH_ACUMATICA_FAILURE_LOGS_FAILURE
} from './acumaticaLogTypes';
import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';

export const getAcumaticaFailurelogs = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [FETCH_ACUMATICA_FAILURE_LOGS_REQUEST, FETCH_ACUMATICA_FAILURE_LOGS_SUCCESS, FETCH_ACUMATICA_FAILURE_LOGS_FAILURE],
      authenticated: true,
      endpoint: 'api/logs/acumatica/failed',
      method: 'GET'
    }
  };
};
